import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { MainLayoutProps } from '../../layouts/MainLayout';
import Hero, { HeroProps } from '../../components/molecules/Hero';
import CardsBlock, { CardsBlockProps } from '../../components/molecules/CardsBlock';
import TwoColumnsLayout from '../../layouts/TwoColumnsLayout';
import RelatedProductsBlock, { RelatedProductsBlockProps } from '../../components/molecules/RelatedProductsBlock';
import CheeseMainContent, { CheeseMainContentProps } from '../../components/molecules/CheeseMainContent';
import HighlightBlock, { HighlightBlockProps } from '../../components/molecules/HighlightBlock';
import TagsCloud, { TagsCloudProps } from '../../components/molecules/TagsCloud';
import { TagsCloudVariant } from '../../components/molecules/TagsCloud/types';
import * as SC from './styled';
export type CheeseTemplateProps = MainLayoutProps & {
  heroProps?: HeroProps;
  mainContentProps?: CheeseMainContentProps;
  sideContent?: React.ReactNode;
  highlightProps?: HighlightBlockProps;
  relatedProductsProps?: RelatedProductsBlockProps;
  relatedRecipesProps?: CardsBlockProps;
  articlesProps?: CardsBlockProps;
  tagsCloudProps?: TagsCloudProps;
};
const CheeseTemplate: FC<CheeseTemplateProps> = ({
  heroProps,
  mainContentProps,
  sideContent,
  highlightProps,
  relatedProductsProps,
  relatedRecipesProps,
  articlesProps,
  tagsCloudProps,
  ...layoutProps
}) => {
  const theme = useTheme();
  return <SC.Layout {...layoutProps}>
      {heroProps && <Hero htmlTag="header" htmlTitleTag="h1" {...heroProps} />}
      <TwoColumnsLayout mainContent={<CheeseMainContent {...mainContentProps} />} sideContent={sideContent} />
      {highlightProps && <HighlightBlock {...highlightProps} />}
      {relatedProductsProps && <RelatedProductsBlock {...relatedProductsProps} />}
      <SC.Bag backgroundColor={theme.colors.chablis}>
        {relatedRecipesProps && <CardsBlock {...relatedRecipesProps} />}
      </SC.Bag>
      {articlesProps && <CardsBlock {...articlesProps} />}
      {tagsCloudProps && <TagsCloud {...tagsCloudProps} variant={TagsCloudVariant.Secondary} />}
    </SC.Layout>;
};
export default CheeseTemplate;